module.exports = __webpack_public_path__ + "static/media/designPatent_30-0993130.b799647b.png";